import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Button from 'shared/Button';

class Navigator extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const disableNext = this.props.submitting || (!this.props.enableNext && !this.props.submitting);

    return (
      <div className={`navigator navigator${this.props.hidePrevious ? '--centered' : ''}`}>
        { this.props.replaceWithMessage !== false ?
          <span className="navigator__message">{ this.props.replaceWithMessage }</span>
          :
          <React.Fragment>
            { !this.props.hidePrevious &&
              <Button
                className="navigator__button__previous"
                onClick={this.onButtonPrevious.bind(this)}
                disabled={!this.props.enablePrevious}
              >
                { this.props.previousLabel }
              </Button>
            }

            <Button
              className="navigator__button__next"
              onClick={this.onButtonNext.bind(this)}
              disabled={disableNext}
              showSpinner={this.props.submitting}
            >
              { this.props.nextLabel }
            </Button>
          </React.Fragment>
        }
      </div>
    );
  }

  onButtonPrevious() {
    if (!this.props.enablePrevious) { return; }

    this.props.onButtonPrevious();
  }

  onButtonNext() {
    if (!this.props.enableNext) { return; }

    this.props.onButtonNext();
  }
}

Navigator.defaultProps = {
  enableNext: true,
  enablePrevious: true,
  hidePrevious: false,
  nextLabel: 'Next',
  previousLabel: 'Previous',
  submitting: false,
  onButtonPrevious: () => {},
  replaceWithMessage: false
};

Navigator.propTypes = {
  enableNext: PropTypes.bool,
  enablePrevious: PropTypes.bool,
  hidePrevious: PropTypes.bool,
  nextLabel: PropTypes.string,
  previousLabel: PropTypes.string,
  submitting: PropTypes.bool,
  onButtonNext: PropTypes.func.isRequired,
  onButtonPrevious: PropTypes.func,
  replaceWithMessage: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool
  ])
};

export default Navigator;
